@if (reiDate(); as date) {
	@let text =
		'chemical.usage-log.rei-expires-at'
			| transloco: { date: date | date: 'MMMM d, yyyy hh:mm aa' };

	<!-- TODO: (Taiga UI migration) [appearance] binding uses a dynamic expression. If it can produce "error"/"success"/"glass", replace with "negative"/"positive"/"secondary-grayscale" -->
	<span
		tuiBadge
		[appearance]="appearance()"
		[iconStart]="icon()"
		[tuiHint]="text"
		tuiHintAppearance="dark"
		[size]="size()"
	>
		<span class="chemical-rei-badge__text">
			{{ text }}
		</span>
	</span>
}
